/* global L */
import BaseDrawer from '../../../utils/map/BaseDrawer'
import { OBJECT } from '../../../utils/map/types'

export default class MappingDrawer extends BaseDrawer {
  _polyData   = []
  _polyLegend = {}
  _polygons   = {}
  _polyId     = null
  
  setPolyData(data = [], legend = {}, id) {
    this.clearPoly()
    this._polyData   = this.dropVueWatchers(data.data || data)
    this._polyLegend = this.dropVueWatchers(legend)
    this._polyId     = id || +new Date()
    this.drawPoly()
  }
  
  isPolyDrawed(id) {
    return this._polyId === id
  }
  
  clearPoly() {
    for (let key in this._polygons) {
      this._polygons[key].remove()
    }
    this._polygons   = {}
    this._polyLegend = {}
    this._polyId     = null
  }
  
  registerOpenPopup(popup) {
    console.warn('registerOpenPopup disabled')
  }
  
  _revertCoords(coords) {
    let out = []
    if (coords.length > 0 && coords[0].length === 2 && !Array.isArray(coords[0][0])) {
      for (let i = 0; i < coords.length; i++) {
        out[i] = [
          coords[i][1], coords[i][0]
        ]
      }
    } else {
      for (let i = 0; i < coords.length; i++) {
        out[i] = this._revertCoords(coords[i])
      }
    }
    return out
  }
  
  _parsePolyCoords(v) {
    let coords = null
    try {
      let parsedJson = JSON.parse(v.geojson)
      if (!parsedJson) {
        console.warn('Empty geojson at', v)
        return null
      }
      if (!Array.isArray(parsedJson.coordinates)) {
        throw new Error('Wrong coordinates format in geojson')
      }
      coords = this._revertCoords(parsedJson.coordinates)
    } catch (e) {
      throw new Error(e)
    }
    return coords.length > 0 ? coords : null
  }
  
  _createModel(v, i) {
    let model = Object.assign({}, v || {})
    delete model.polygon
    model.type = OBJECT.OFFLINE
    if (!model.hasOwnProperty('model')) {
      model.model = model
    }
    
    if (this._polyLegend.popup && this._polyLegend.popup.head && this._polyLegend.popup.fields) {
      model.head      = this._polyLegend.popup.head
      model.fields    = this._polyLegend.popup.fields
      model._hasPopup = true
    } else if (model.popup && model.popup.head && model.popup.fields) {
      model.head      = model.popup.head
      model.fields    = model.popup.fields
      model._hasPopup = true
    }
    model.id = model.id || i
    return model
  }
  
  _parseLegendItem(v, legend) {
    if (!legend.hasOwnProperty('valueKey')) {
      console.error('Unknown valueKey in ', legend)
      return null
    }
    if (legend.valueKey === false) {
      if (legend.items && Array.isArray(legend.items) && legend.items.length > 0) {
        return legend.items[0]
      }
      console.error('Not found items[0] in ', legend)
      return null
    }
    if (!v[legend.valueKey]) {
      console.warn('Please check property ' + legend.valueKey + 'value in', v)
    }
    let value   = v[legend.valueKey] || 0
    let current = null
    for (let i = 0; i < legend.items.length; i++) {
      if (value >= legend.items[i].min) {
        current = legend.items[i]
      }
    }
    return current
  }
  
  drawPoly() {
    console.log('Start draw poly')
    this._polyData.forEach((v, i) => {
      let coords     = this._parsePolyCoords(v)
      let model      = this._createModel(v, i)
      let legendItem = this._parseLegendItem(v, this._polyLegend)
      if (coords && legendItem) {
        let { style = {} } = legendItem
        this._polygons[i]  = L.polygon(coords, {
          weight:      (style.weight || model.weight || 1),
          opacity:     (style.opacity || model.opacity || 0.8),
          color:       (style.color || model.color),
          fillColor:   (model.color || style.fillColor || style.color || model.fillColor),
          fillOpacity: (style.fillOpacity || style.opacity || model.fillOpacity || model.opacity || 0.4),
          model,
          type:        model.type,
          id:          model.id
        }).addTo(this._map)

        if (model._hasPopup === true) {
          this._polygons[i].on('click', () => {
            try {
              this.createPopup(this._polygons[i])
            } catch (e) {
              console.error(e)
            }
          })
        }
      } else {
        console.warn('Unknown model or value or coords empty')
      }
    })
  }
}
